import clsx from 'clsx';
import React from 'react';

import {
  alignmentValues,
  backgroundColorValues,
  fontFamilyValues,
  fontSizeValues,
  marginValues,
  paddingValues,
} from './constants';
import type { TextBlockProps } from './interfaces';

const TextBlock = ({ config, children }: TextBlockProps) => {
  return (
    <div
      className={clsx(
        'text-block my-24',
        config?.css_classes,
        alignmentValues[config?.alignment],
        backgroundColorValues[config?.background_color],
        backgroundColorValues[config?.background_color] && 'px-20',
        fontFamilyValues[config?.font_family],
        fontSizeValues[config?.font_size],
        marginValues[config?.margin],
        paddingValues[config?.padding]
      )}
    >
      {children}
    </div>
  );
};

export default TextBlock;
